export default function getCartShopId(cart) {
  return cart?.restaurant;
}
